import WebApp from "@twa-dev/sdk";
import { ADMIN_IDS, ROLES } from "../config/app";

// Получение данных пользователя Telegram
export function getTelegramUser() {
  if (!WebApp.initDataUnsafe?.user) {
    throw new Error("Приложение должно быть запущено в Telegram WebApp");
  }
  return WebApp.initDataUnsafe.user;
}

// Получение initData для авторизации на сервере
export function getTelegramInitData() {
  if (!WebApp.initData) {
    throw new Error("Telegram initData не доступен. Приложение должно быть запущено в Telegram WebApp");
  }
  return WebApp.initData;
}

// Получение start_param для deep linking
export function getTelegramStartParam() {
  return WebApp.initDataUnsafe?.start_param || null;
}

// Проверка роли пользователя (админ или менеджер)
export function getUserRole(userId) {
  return ADMIN_IDS.includes(userId) ? ROLES.ADMIN : ROLES.MANAGER;
}

// Получение имени менеджера
export function getManagerName(user) {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name.charAt(0)}.`;
  }
  return user.first_name || user.username || "Manager";
}

// Функция для отправки запросов на сервер с авторизацией
export async function authenticatedFetch(url, options = {}) {
  const initData = getTelegramInitData();
  
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `tma ${initData}`,
    ...options.headers,
  };
  
  return fetch(url, {
    ...options,
    headers,
  });
}
